// *******************************************************************************
// Change images and price based on selections
// *******************************************************************************

const productModule = document.querySelector('.product-module');
const productModuleShowcase = productModule?.querySelector('.product-module__showcase');

if (productModule) {
  // Update product module data
  const updateProductModule = (response) => {
    if (response) {
      productModuleShowcase.innerHTML = response.galleryHtml;
      initProductSlider();
    }
  };

  // Axios show filtered product data based on selected colors and other parameters
  const axiosShowChildProductData = async (params, colorParam) => {
    const data = {
      id: localData.id,
      lang: localData.lang,
      action: 'showChildProductData',
      urlParameters: JSON.stringify(params),
      colorParam: JSON.stringify(colorParam),
    };

    try {
      const response = await axios.post(localData.siteURL, data);
      updateProductModule(response.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  // ajax call only if any radio clicked
  const productModuleAllInputs = productModule.querySelectorAll('input[type="radio"]');
  productModuleAllInputs.forEach((inputs) => {
    inputs?.addEventListener('click', () => {
      const ajaxParams = {};
      const colorParams = {};

      // Get selected color, or select the first one if none is selected
      let colorSelected = false;
      const colorRadioButtons = productModule.querySelectorAll('input[type="radio"].product-color:checked');
      colorRadioButtons?.forEach((color) => {
        ajaxParams[color.name] = color.value;
        colorParams[color.name] = color.value;
        colorSelected = true;
      });
      if (!colorSelected) {
        const firstColorRadio = productModule.querySelector('input[type="radio"].product-color');
        if (firstColorRadio) {
          firstColorRadio.checked = true;
          ajaxParams[firstColorRadio.name] = firstColorRadio.value;
          colorParams[firstColorRadio.name] = firstColorRadio.value;
        }
      }

      // Get selected size for each group, or select the first one if none is selected
      const sizesGroup = productModule.querySelectorAll('.available-sizes__group');
      sizesGroup?.forEach((group) => {
        let sizeSelected = false;
        const sizesRadioButtons = group.querySelectorAll('input[type="radio"].product-sizes:checked');
        sizesRadioButtons?.forEach((size) => {
          ajaxParams[size.name] = size.value;
          sizeSelected = true;
        });
        if (!sizeSelected) {
          const firstSizeRadio = group.querySelector('input[type="radio"].product-sizes');
          if (firstSizeRadio) {
            firstSizeRadio.checked = true;
            ajaxParams[firstSizeRadio.name] = firstSizeRadio.value;
          }
        }
      });

      axiosShowChildProductData(ajaxParams, colorParams);
    });
  });
}
